<template>
  <div class="open-page-logo" @click="goHome">
    <img :class="{ 'custom-logo': hasCustomLogo }" :src="logoSrc" alt="" />
  </div>
</template>

<script>
export default {
  name: 'OpenPageLogo',
  computed: {
    currentDomainConfig() {
      return this.$store.state.app.currentColorLogo || {};
    },
    hasCustomLogo() {
      return Boolean(this.currentDomainConfig.logo);
    },
    logoSrc() {
      return this.currentDomainConfig.logo || require('@/assets/logo.png');
    },
  },
  methods: {
    goHome() {
      this.$router.replace({
        path: '/',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.open-page-logo {
  flex: 0 0 auto;
  height: 48px;
  margin-right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  img {
    width: 72px;
    height: auto;
    display: block;

    &.custom-logo {
      width: auto;
      height: 44px;
    }
  }
}
</style>
